import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of, forkJoin } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';
import { GridApi, IGetRowsParams } from 'ag-grid-community';
import { environment } from "../../../environments/environment";
import { buildAetUserContext } from 'src/app/core/constant/user-context.util';


@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    pageSize: any = 10;
    apiUrl = environment.baseAPIURL+'/aetNotifications';
    private readonly httpBypass: HttpClient;
    constructor(private readonly http: HttpClient, httpBackend: HttpBackend) {
        // httpBypass skips AddParamsInterceptor so the GraphQL payload is not corrupted
        this.httpBypass = new HttpClient(httpBackend);
    }

    // Get all notifications
    getNotifications(params?: any): Observable<any> {
        const currentPage = Math.floor(params.startRow/params?.pageSize)+1;


        return this.http.get<any>(`${this.apiUrl}/getNotifications/${currentPage}/${params?.pageSize}`);
    }

     // Get all notifications
     getNotificationsNew(): Observable<any> {

        return this.http.get<any>(`${this.apiUrl}/getNotifications`);
    }

    // Filter notifications
    filterNotifications(filters: { name?: string; userIds?: string }, params: any): Observable<any> {
        const currentPage = Math.floor(params.startRow/params?.pageSize)+1;
        let paramsData = new HttpParams();

        if (filters?.name) {
            paramsData = paramsData.set('name', filters.name);
        }
        if (filters?.userIds) {
            paramsData = paramsData.set('userIds', filters.userIds);
        }
        
        return this.http.get<any>(`${this.apiUrl}/filterNotifications/${currentPage}/${params?.pageSize}`, { params: paramsData });

    }

    // Add a notification
    addNotification(data: any): Observable<any> {
        const rb = { event: data, userReqDto: buildAetUserContext() };
        return this.http.post<any>(`${this.apiUrl}/saveNotification`, rb);
    }

    // Edit a notification
    editNotification(data: any): Observable<any> {
        const rb = { event: data, userReqDto: buildAetUserContext() };
        return this.http.put<any>(`${this.apiUrl}/editNotification`, rb);
    }

    // Delete a notification
    deleteNotification(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/deleteNotification/${id}`,{responseType:'text'});
    }

    // Get Edit notification
    getEditNotification(id: any): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/editNotification/${id}`);
    }

    // Get Criteria Filters
    getCriteriaFilters(): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/GetCriteriaFilters`);

    }
    searchUsers(filters: string): Observable<any> {
        const token = sessionStorage.getItem('accessToken');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : '',
        });
        const parts = filters.trim().split(/\s+/);
        const firstName = parts[0] || null;
        const lastName = parts.length > 1 ? parts[1] : null;
        const query = `
            query listUsersByFilters($firstName: String, $lastName: String) {
                listUsersByFilters(firstName: $firstName, lastName: $lastName) {
                    userId
                    userPrincipalName
                    externalUserId
                    email
                    firstName
                    lastName
                    displayName
                }
            }
        `;
        return this.httpBypass
            .post<any>(
                environment.APM_DS_URI,
                { query, variables: { firstName, lastName } },
                { headers }
            )
            .pipe(
                map(res => res?.data?.listUsersByFilters ?? []),
                catchError(() => of([]))
            );
    }

    getUsersByIds(data: string[]): Observable<any[]> {
        if (!data?.length) return of([]);
        const token = sessionStorage.getItem('accessToken');
        const headers = new HttpHeaders({
            'Content-Type': 'application/json',
            Authorization: token ? `Bearer ${token}` : '',
        });
        const query = `
            query getUserByUPN($userPrincipalName: String!) {
                getUserByUPN(userPrincipalName: $userPrincipalName) {
                    userId
                    userPrincipalName
                    externalUserId
                    email
                    firstName
                    lastName
                    displayName
                }
            }
        `;
        const requests = data.map(userPrincipalName =>
            this.httpBypass
                .post<any>(environment.APM_DS_URI, { query, variables: { userPrincipalName } }, { headers })
                .pipe(
                    map(res => res?.data?.getUserByUPN ?? null),
                    catchError(() => of(null))
                )
        );
        return forkJoin(requests).pipe(
            map(users => users.filter(u => u !== null))
        );
    }

    filterNotificationsNew(filters: { name?: string; userIds?: string } ): Observable<any> {
        let paramsData = new HttpParams();

        if (filters?.name) {
            paramsData = paramsData.set('name', filters.name);
        }
        if (filters?.userIds) {
            paramsData = paramsData.set('userIds', filters.userIds);
        }
        
        return this.http.get<any>(`${this.apiUrl}/filterNotifications`, { params: paramsData });

    }
      
}